var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73685 11.2388V5.83723C6.737 5.74055 6.77584 5.64787 6.84486 5.57951C6.91388 5.51115 7.00744 5.47267 7.10505 5.47252H14.1188V4.41151C14.1188 4.30237 14.075 4.1977 13.9971 4.12053C13.9192 4.04336 13.8135 4 13.7033 4H1.41545C1.36092 3.99993 1.30691 4.0105 1.25651 4.03112C1.20611 4.05174 1.1603 4.08199 1.12172 4.12016C1.08313 4.15833 1.05252 4.20365 1.03164 4.25355C1.01075 4.30344 1 4.35692 1 4.41094V10.5031C1.00031 12.226 1.69157 13.8783 2.92173 15.0965C4.15189 16.3146 5.8202 16.9989 7.55969 16.9987C8.44474 16.9998 9.32079 16.8229 10.1348 16.4788C9.1213 16.0194 8.2623 15.2813 7.65993 14.3524C7.05756 13.4235 6.73717 12.3428 6.73685 11.2388Z",
    fill: "url(#paint0_linear_1385_17881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3695 5.83721C18.3694 5.74053 18.3305 5.64785 18.2615 5.57949C18.1925 5.51113 18.0989 5.47265 18.0013 5.4725H14.1187V10.5031C14.1188 11.7763 13.7412 13.0215 13.033 14.0841C12.3247 15.1467 11.3169 15.9797 10.1348 16.4799C10.8942 16.8239 11.7198 17.0013 12.5549 16.9999C14.0972 16.9994 15.5762 16.3922 16.6666 15.3119C17.757 14.2315 18.3695 12.7664 18.3695 11.2387V5.83721Z",
    fill: "url(#paint1_linear_1385_17881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17881",
    x1: 0.559768,
    y1: 16.3692,
    x2: 9.88061,
    y2: 4.99074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#210D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#361463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#581F85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1385_17881",
    x1: 12.9738,
    y1: 16.4771,
    x2: 18.6738,
    y2: 3.10777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.32810aa63a809b7ad8ed001e7342ea83.svg";
export { ForwardRef as ReactComponent };